import { faAddressCard, faCheckCircle, faPencilAlt, faPlusCircle, faSave, faTimesCircle, faTrash, faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GridCellProps, GridHeaderCell } from "@progress/kendo-react-grid";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import React from "react";
import { history } from "../../../../../HelperMethods";
import { AppPermissions } from "../../../../Shared/Constants/AppPermissions";
import auth from "../../../../Auth";
import { LocalizationHelper } from "../../../../../Localization/helpers/LocalizationHelper";
import { LocalizationResource } from "../../../../Shared/AppConstants";

export function CustomHeaderActionCell({ add }) {
    return class extends GridHeaderCell {
      handleHeaderMenuClick = (actionValue: number) => {
        console.log("Action Taken " + actionValue);
      };
  
      render() {
        const contentAddRender = (props) => {
          return (
            <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={() => add(props.dataItem)}>
              <FontAwesomeIcon icon={faPlusCircle} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Add {LocalizationHelper.getLocalizedTitle(LocalizationResource.Department_Label, "Department")}{" "}
            </div>
          );
        }
  
        const menuRender = (props) => {
          return <span className="k-icon k-i-more-horizontal" style={{ color: "white" }}></span>;
        };
  
        return (
          <Menu openOnClick={true} className="actionItemMenu actionItemMenuThreeDots">
            <MenuItem render={menuRender} key={"parentMenu"}>
              <MenuItem render={contentAddRender} key={"addBtn"} />
              {/* <MenuItem disabled={!canRemove} render={contentRemoveRender} key={"removeBtn"} /> */}
            </MenuItem>
          </Menu>
        );
  
      }
    };
  }


export function MyCommandCell({ edit, remove, update, cancel, editField, add, discard, updateStatus, redirectTo, viewSchedule, shiftScheduling }) {
    return class extends React.Component<GridCellProps> {
      
      render() {
        const { dataItem, dataIndex } = this.props;
        const inEdit = dataItem[editField];
        const isNewItem = dataItem.id === undefined;
        const isDraft = dataItem.status == "Draft";
        console.table(dataItem);
        const menuRender = (props) => {
          return <span className="k-icon k-i-more-horizontal"></span>;
        };

        const contentViewSchedule = (props) => {
            return (
                <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={() => viewSchedule(dataItem)}>
                <FontAwesomeIcon icon={faPlusCircle} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> View Schedule{" "}
              </div>
            )
        
        }

        const contentDefaultShift = (props, dataItems,locationId) => {
          console.log(props,"tset",dataItems,"ytewsd",locationId,"sdgh");
          return (
                <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={() => redirectTo(dataItem)}>
                  <FontAwesomeIcon icon={faAddressCard} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Default Shift{" "}
                </div>
          );
        }

        const discardOrCancel = (props) => {
          return (
            <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={() => (isNewItem ? discard(dataItem) : cancel(dataItem))}>
              <FontAwesomeIcon icon={isNewItem ? faTrash : faUndo} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> {isNewItem ? "Remove" : "Reset"}{" "}
            </div>
          );
        }

        const contentRemove = (props) => {
          return (
            <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={() => remove(dataItem)}>
              <FontAwesomeIcon icon={faTrash} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Remove{" "}
            </div>
          );
        }

        const contentStatusChange = () => {
          const isActive = dataItem.status == "Active";
          return (
              <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={() => updateStatus(dataItem)}>
                <FontAwesomeIcon icon={isActive ? faTimesCircle : faCheckCircle} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> {isActive ? "Deactivate" : "Activate"}{" "}
              </div>
          );
        }

        const renderMenuItems = (dataItem, shiftSchedule) => {
          return (
            <span style={{display: 'inline-grid', position: 'relative', top: "5px"}}>
              <Menu openOnClick={true} className="actionItemMenu actionItemMenuThreeDots">
                <MenuItem render={menuRender} key={"parentMenu"}>
                {auth.hasPermissionV2(AppPermissions.VIEW_SCHEDULE) &&
                (!isDraft && shiftSchedule == true && <MenuItem render={contentViewSchedule} key={"addBtn"} /> )}
                {!isDraft && shiftSchedule == true && <MenuItem render={contentDefaultShift} key={"addDefaultShiftBtn"} /> }
                {!isDraft && <MenuItem render={contentStatusChange} key={"activeInactive"} /> }
                  {dataItem.inEdit ?
                    <MenuItem render={discardOrCancel} key={"remove"}/>
                  :
                    <MenuItem render={contentRemove} key={"remove"}/>
                  }
                  </MenuItem>
              </Menu>
            </span>
          )
        }

        return inEdit ? (
          <>
            <td className="k-command-cell  k-command-cell-icon" contextMenu="Action">
              <div className="txt-clr-blue">
                <span
                  className={"font-medium"+ ((dataItem.name && dataItem.name.trim() && dataItem.name.length <= 100)  ? " " : " disable-opacity")}
                  style={{ marginRight: "12px", cursor: "pointer" }}
                  title={isNewItem ? "Add" : "Update"}
                  onClick={() => (isNewItem ? add(dataItem, dataIndex) : update(dataItem))}
                >
                  <FontAwesomeIcon icon={faSave} />
                </span>
                  {renderMenuItems(dataItem, shiftScheduling)}
              </div>
            </td>
          </>
        ) : (
          <>
            <td className="k-command-cell k-command-cell-icon" contextMenu="Action">
              <div className="txt-clr-blue">
                <span
                  className="font-medium"
                  style={{ paddingRight: "12px", cursor: "pointer" }}
                  onClick={() => edit(dataItem)}
                >
                  <FontAwesomeIcon icon={faPencilAlt} />
                </span>
                {renderMenuItems(dataItem, shiftScheduling)}
              </div>
            </td>
          </>
        );
      }
    };
  }